<template>
  <div class="home">
    <div v-if="loadingCodeInfo">Laddar lite information...</div>
    <div v-else>
      <div v-if="!codeSuccess">
        <div><strong>Hoppsan!</strong></div>
        <p>Det ser ut som om du har angivit en återställningskod som är felaktig eller som har gått ut. Prova att återställa ditt lösenord igen.</p>
        <p>Om ovanstående inte fungerar, kontakta support@nexa.se</p>
      </div>
      <div v-else>
        <div v-if="!success">
          <div style="text-align:center;padding:20px;">
            <h3 style="padding-bottom:0px;">Ändra e-post från</h3>
            <h5 style="margin-bottom:10px;">{{ oldEmail.length ? oldEmail : '-' }}</h5>
            
            <div style="font-size:13px;">
              <div v-if="!error.length">Skriv in din nya e-post nedanför. Du kommer att få ett nytt mejl till den nya e-posten där du behöver bekräfta ändringen.</div>
              <div v-else>
                <div style="color:#e74c3c">{{ (error in errorMessages ? errorMessages[error] : error) }}</div>
              </div>
            </div>
          </div>
          
          <div style="padding:20px;padding-top:5px;">
            <div><input class="input" type="email" placeholder="E-post" v-model="newEmail"></div>
            <div style="text-align:center;"><button class="submit" :disabled="!ok" @click="restore">Uppdatera e-post</button></div>
          </div>
        </div>
        <div v-else>
          <div v-if="success">
            <strong>Bekräfta e-postbytet</strong>
            <p>Du har fått ett mejl till {{  newEmail }} med fler instruktioner.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.home {
  margin:12px;
}
</style>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {},
  created () {

  },
  mounted () {
    fetch(`https://api.systemnexa2.se/1/account/email/validate-code?code=${this.$route.params.code}`)
    .then(res => res.json())
    .then(json => {
      if (json.success) {
        this.oldEmail = json.data.email
      }

      this.codeSuccess = json.success
      this.loadingCodeInfo = false
    })
  },
  data: () => ({
    oldEmail: '',
    newEmail: '',
    restored: false,
    success: false,
    error: '',
    codeSuccess: false,
    loadingCodeInfo: true,
    loading: false,
    errorMessages: {
      invalid_email_password: 'Ogiltlig e-post eller lösenord har angivits, försök igen!'
    }
  }),
  methods: {
    // restore
    //
    //
    async restore () {
      this.loading = true

      const response = await fetch('https://api.systemnexa2.se/1/account/email/change', {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: this.newEmail,
          code: this.$route.params.code
        })
      })

      const json = await response.json()

      this.loading = false
      this.restored = true
      this.success = json.success
      this.error = json.message
      if (!this.success) {
        this.newEmail = ''
      }

      if (!this.success) {
        setTimeout(() => {
          this.restored = false
          this.success = false
          this.error = ''
        }, 4000)
      }
      
      console.log(json)
    }
  },
  computed: {
    ok () {
      return this.newEmail.length >= 3 && this.newEmail.includes('@') && this.newEmail.includes('.') && !this.loading
    }
  }
}
</script>
